import { atomWithStorage } from 'jotai/utils';

/**
 * This is the lowest priority for set language. It is mostly used for setting the language and propagating is to where the user is created
 */
export const languageAtom = atomWithStorage<string>('languageAtom', 'en');
